import { Route, Routes } from 'react-router-dom';
import Login from '../pages/Home/Login';
import { CreateOrg } from '../pages/CreateOrganization/CreateOrg';
import { OrgView } from '../pages/OrgView/OrgView';
import { CreateUser } from '../pages/CreateUser/CreateUser';
import { OrgHome } from '../pages/Home/OrgHome';
import UserListDashboard from '../pages/UserListDashboard/UserListDashboard';
import UserProfile from '../pages/UserProfile/UserProfile';
import { AppLayout } from '../layout/AppLayout';
import GlobalSearch from '../pages/GlobalSearch/GlobalSearch';
import Notifications from '../pages/Notifications/Notifications';


export function Menu() {
    return (
        <Routes>
            {/* Public routes - no authentication required */}
            <Route path="/" element={<Login />} />
            
            {/* Protected routes - wrapped in layout with sidebar */}
            <Route path="/*" element={<AppLayout />}>
                {/* Organization routes with optional orgId parameter */}
                <Route path="org-home" element={<OrgHome />} />
                <Route path="org-home/:orgId" element={<OrgHome />} />
                
                <Route path="org-view" element={<OrgView />} />
                <Route path="org-view/:orgId" element={<OrgView />} />
                
                <Route path="user-list-dashboard" element={<UserListDashboard />} />
                <Route path="user-list-dashboard/:orgId" element={<UserListDashboard />} />

                <Route path="notifications" element={<Notifications />} />
                <Route path="notifications/:orgId" element={<Notifications />} />

                <Route path="create-org" element={<CreateOrg />} />
                <Route path="create-org/:orgId" element={<CreateOrg />} />
                
                <Route path="create-user" element={<CreateUser />} />
                <Route path="create-user/:orgId" element={<CreateUser />} />
                
                {/* User profile with required parameters */}
                <Route path="user-profile/:orgId/:userId" element={<UserProfile />} />

                {/* Global Search */}
                <Route path="search" element={<GlobalSearch />} />
            </Route>
        </Routes>
    )
}
export default Menu;